export default {
  "content": "<path d=\"M11 15.5H4.5v-7H11v7z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17 5a3 3 0 013 3v8a3 3 0 01-3 3H4a3 3 0 01-2.996-2.846L1 16V8a3 3 0 013-3h13zM4 7a1 1 0 00-1 1v8l.005.102A1 1 0 004 17h13a1 1 0 001-1V8a1 1 0 00-1-1H4z\" fill=\"#7B61FF\"/><path d=\"M23.5 14.5h-2v-5h2v5z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};